<script>
    import { Meteor } from "meteor/meteor";
    import { FlowRouter } from "meteor/ostrio:flow-router-extra";

    let username = $state("");
    let password = $state("");
    let errorMessage = $state("");
    let loading = $state(false);

    function submit(event) {
        event.preventDefault();
        loading = true;
        errorMessage = "";

        Meteor.loginWithPassword(username, password, (error) => {
            loading = false;
            if (error) {
                errorMessage = error.reason || "Login failed.";
                return;
            }

            FlowRouter.go("/mgmt/inventory");
        });
    }
</script>

<section class="login-card">
    <h1>Management Login</h1>
    <form onsubmit={submit}>
        <label>Username<input required bind:value={username} /></label>
        <label
            >Password<input
                required
                type="password"
                bind:value={password}
            /></label
        >
        <button type="submit" disabled={loading}
            >{loading ? "Logging in..." : "Login"}</button
        >
        {#if errorMessage}<p class="error">{errorMessage}</p>{/if}
    </form>
</section>
